import { Instagram, Music2, Linkedin } from 'lucide-react';
interface EmailPreviewProps {
  firstName?: string;
}
const EmailPreview = ({
  firstName = 'Voyager'
}: EmailPreviewProps) => {
  return <>
      <style>{`
        @media (max-width: 640px) {
          .email-container {
            padding: 20px 16px !important;
          }
          .email-logo {
            width: 150px !important;
          }
          .email-heading {
            font-size: 24px !important;
            margin: 0 0 16px !important;
          }
          .email-text {
            font-size: 14px !important;
            line-height: 22px !important;
          }
          .email-feature-box {
            padding: 20px 16px !important;
            margin: 24px 0 !important;
          }
          .email-feature-heading {
            font-size: 20px !important;
            margin: 0 0 12px !important;
          }
          .email-button {
            padding: 12px 20px !important;
            font-size: 14px !important;
          }
          .email-social-icon {
            width: 24px !important;
            height: 24px !important;
          }
        }
      `}</style>
      <div style={{
      backgroundColor: '#f0fafa',
      minHeight: '100vh',
      padding: '20px 20px',
      fontFamily: "Montserrat, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
    }}>
        <div className="email-container" style={{
        backgroundColor: '#ffffff',
        margin: '0 auto',
        padding: '20px 20px 40px',
        borderRadius: '8px',
        maxWidth: '600px'
      }}>
          <div style={{
          textAlign: 'center',
          marginBottom: '0'
        }}>
            <img src="/lovable-uploads/odyvoy-logo.png" alt="OdyVoy Logo" className="email-logo" style={{
            width: '250px',
            height: 'auto',
            margin: '0 auto'
          }} />
          </div>
          <h1 className="email-heading" style={{
          color: '#1a9a9a',
          fontSize: '32px',
          fontWeight: 'bold',
          margin: '8px 0 24px',
          padding: '0',
          textAlign: 'center'
        }}>
            Welcome to OdyVoy! ✈️
          </h1>
        
        <p className="email-text" style={{
          color: '#333',
          fontSize: '16px',
          lineHeight: '24px',
          margin: '16px 0'
        }}>
          Hi {firstName},
        </p>
        
        <p className="email-text" style={{
          color: '#333',
          fontSize: '16px',
          lineHeight: '24px',
          margin: '16px 0'
        }}>
          We're truly glad you've joined the OdyVoy family! Your next travel adventure just became a lot simpler, smarter, and more fun.
        </p>
        
        <div className="email-feature-box" style={{
          background: 'linear-gradient(135deg, #1a9a9a, #6dd4d4)',
          borderRadius: '8px',
          padding: '24px',
          margin: '32px 0'
        }}>
          <h2 className="email-feature-heading" style={{
            color: '#ffffff',
            fontSize: '24px',
            fontWeight: 'bold',
            margin: '0 0 16px',
            padding: '0'
          }}>Ready to Start Your Journey?</h2>
          
          <p className="email-text" style={{
            color: '#ffffff',
            fontSize: '16px',
            lineHeight: '24px',
            margin: '16px 0'
          }}>Create Your First Trip and Unlock a World of Features:</p>
          
          <ul style={{
            margin: '16px 0',
            padding: '0 0 0 20px'
          }}>
            <li className="email-text" style={{
              color: '#ffffff',
              fontSize: '16px',
              lineHeight: '28px',
              margin: '8px 0'
            }}>
              ✨ AI-Powered Personalized Lists
            </li>
            <li className="email-text" style={{
              color: '#ffffff',
              fontSize: '16px',
              lineHeight: '28px',
              margin: '8px 0'
            }}>
              🛂 Visa Requirements Check
            </li>
            <li className="email-text" style={{
              color: '#ffffff',
              fontSize: '16px',
              lineHeight: '28px',
              margin: '8px 0'
            }}>
              🗺️ Local Destination Tips
            </li>
            <li className="email-text" style={{
              color: '#ffffff',
              fontSize: '16px',
              lineHeight: '28px',
              margin: '8px 0'
            }}>
              🌡️ Health & Wellness Preparation
            </li>
            <li className="email-text" style={{
              color: '#ffffff',
              fontSize: '16px',
              lineHeight: '28px',
              margin: '8px 0'
            }}>
              ✈️ Jet Lag Minimizer
            </li>
            <li className="email-text" style={{
              color: '#ffffff',
              fontSize: '16px',
              lineHeight: '28px',
              margin: '8px 0'
            }}>
              💱 Smart Currency Converter
            </li>
            <li className="email-text" style={{
              color: '#ffffff',
              fontSize: '16px',
              lineHeight: '28px',
              margin: '8px 0'
            }}>💰 Group Expense Sharing</li>
          </ul>
          
          <a href="/dashboard" className="email-button" style={{
            backgroundColor: '#f0d763',
            borderRadius: '6px',
            color: '#1a9a9a',
            fontSize: '16px',
            fontWeight: 'bold',
            textDecoration: 'none',
            textAlign: 'center',
            display: 'block',
            padding: '14px 24px',
            margin: '24px 0'
          }}>
            Plan Your First Trip
          </a>
        </div>

        <hr style={{
          borderColor: '#e6e6e6',
          margin: '32px 0'
        }} />

        <p className="email-text" style={{
          color: '#333',
          fontSize: '16px',
          lineHeight: '24px',
          margin: '16px 0'
        }}>
          Need help getting started? Check our quick start guide or reach out to our team—OdyVoy support is always here for you.
        </p>

        <p className="email-text" style={{
          color: '#333',
          fontSize: '16px',
          lineHeight: '24px',
          marginTop: '32px'
        }}>
          Wishing you safe travels and unforgettable adventures,
          <br />
          The OdyVoy Team 🌟
        </p>

        <hr style={{
          borderColor: '#e6e6e6',
          margin: '32px 0'
        }} />

        <div style={{
          textAlign: 'center',
          margin: '32px 0'
        }}>
          <p className="email-text" style={{
            color: '#333',
            fontSize: '16px',
            fontWeight: 'bold',
            marginBottom: '16px'
          }}>
            Stay Connected With Us
          </p>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            flexWrap: 'wrap',
            alignItems: 'center'
          }}>
            <a href="https://www.instagram.com/odyvoy_/" style={{
              textDecoration: 'none',
              color: '#64748b',
              transition: 'color 0.2s'
            }} aria-label="Follow us on Instagram">
              <Instagram className="email-social-icon" size={28} strokeWidth={1.5} />
            </a>
            <a href="https://www.tiktok.com/@odyvoy_" style={{
              textDecoration: 'none',
              color: '#64748b',
              transition: 'color 0.2s'
            }} aria-label="Follow us on TikTok">
              <Music2 className="email-social-icon" size={28} strokeWidth={1.5} />
            </a>
            <a href="https://www.linkedin.com/company/odyvoy/about/?viewAsMember=true" style={{
              textDecoration: 'none',
              color: '#64748b',
              transition: 'color 0.2s'
            }} aria-label="Follow us on LinkedIn">
              <Linkedin className="email-social-icon" size={28} strokeWidth={1.5} />
            </a>
          </div>
          
        </div>

        <hr style={{
          borderColor: '#e6e6e6',
          margin: '32px 0'
        }} />

        <p style={{
          color: '#8898aa',
          fontSize: '12px',
          lineHeight: '16px',
          marginTop: '16px',
          textAlign: 'center'
        }}>
          You're receiving this email because you signed up for OdyVoy with your email address.
        </p>

        <div style={{
          textAlign: 'center',
          marginTop: '24px',
          paddingTop: '24px',
          borderTop: '1px solid #e6e6e6'
        }}>
          <p style={{
            color: '#8898aa',
            fontSize: '12px',
            lineHeight: '18px',
            margin: '8px 0'
          }}>
            <strong>OdyVoy</strong>
          </p>
          <p style={{
            color: '#8898aa',
            fontSize: '12px',
            lineHeight: '18px',
            margin: '8px 0'
          }}>Your AI-Powered Travel Companion</p>
          <p style={{
            color: '#8898aa',
            fontSize: '12px',
            lineHeight: '18px',
            margin: '16px 0'
          }}>
            <a href="/unsubscribe" style={{
              color: '#1a9a9a',
              textDecoration: 'underline'
            }}>Unsubscribe</a>
            {' | '}
            <a href="/privacy" style={{
              color: '#1a9a9a',
              textDecoration: 'underline'
            }}>Privacy Policy</a>
            {' | '}
            <a href="/terms" style={{
              color: '#1a9a9a',
              textDecoration: 'underline'
            }}>Terms of Service</a>
          </p>
          <p style={{
            color: '#8898aa',
            fontSize: '11px',
            lineHeight: '16px',
            margin: '16px 0'
          }}>
            © {new Date().getFullYear()} OdyVoy. All rights reserved.
          </p>
        </div>
        </div>
      </div>
    </>;
};
export default EmailPreview;